<template>
    <!-- <tr class="w-full border-b-[1px] border-[#FFF] border-opacity-10">
        <td @click="$emit('openTrainerCard')" class="pl-3 pr-2 py-2 text-start text-sm w-[5%] cursor-pointer">
            <div class="w-10 h-10 rounded-full overflow-hidden flex items-end bg-[#BD9135] bg-opacity-20 border-[#BD9135] border-[1px]">
                <img v-if="trainer.photo" :src="apiURL + 'static/' + trainer.photo">
                <div v-else class="w-full h-full  text-[#BD9135] flex justify-center items-center">
                    {{ trainer.name[0] + trainer.surname[0] }}
                </div>
            </div>
        </td>
        <td @click="$emit('openTrainerCard')" class="px-3 py-2 text-start text-sm w-[15%] cursor-pointer">
            <div class="flex flex-col">
                <div class="truncate text-[#FFF]">{{ trainer.surname }} {{ trainer.name[0] + '.' }}</div>
                <div class="truncate text-sm text-gray-400">{{ trainer.phone }}</div>
            </div>
        </td>
        <td class="px-3 py-2 truncate w-[15%] text-start text-sm text-[#FFF]">
            <span v-if="typeof groups != 'null'">{{ groups ? groups.join(', ').length > 20 ? groups.join(', ').slice(0, 20) + '...' : groups.join(', ') : '—' }}</span>
            <Skeletor v-else width="70" height="15" pill as="div" :shimmer="true"/>
        </td>
        <td class="px-3 py-2 text-end text-sm w-[15%] text-[#FFF]">
            <span v-if="typeof activeStudentsCount == 'number' ">{{ activeStudentsCount }}</span>
            <Skeletor v-else width="40" class="ml-auto" height="15" pill as="div" :shimmer="true"/>
        </td>
        <td class="px-3 py-2 text-end text-sm w-[10%]"></td>
        <td class="px-3 py-2 text-center text-sm w-[25%]">
            <div class="flex justify-center" v-for="s in ['active',]">
                <div v-if="s == 'active'" class="bg-[#339989] mx-1 h-[18px] pb-[2px] flex justify-center items-center rounded-full w-[88px] text-[13px] text-center text-[#fff]">
                    <div>
                        Активний
                    </div>
                </div>  
                <div v-if="s == 'archive'" class="bg-[#8FC408] mx-1 h-[18px] pb-[2px] flex justify-center items-center rounded-full w-[88px] text-[13px] text-center text-[#fff]">
                    Архів
                </div> 
            </div>
        </td>
        <td class="px-3 py-2 select-none text-end text-sm w-[15%]">
            <button @click="$emit('openTrainerCard')" class="px-2 py-1 rounded-[10px] text-sm font-medium">
                <img src="@/assets/icons/pen_icon.svg" class="w-6 h-6">
            </button>
            <button v-if="currentAdminRole != 'supervisor'" @click="$emit('deleteTrainer', trainer)" class="px-2 py-1 rounded-[10px] text-sm font-medium text-red-600">
                <img src="@/assets/icons/trash_icon.svg" class="w-6 h-6">
            </button>
        </td>
    </tr> -->

    <TableRow>
        <TableCell :asChild="true">
            <AvatarContainer
                :src="apiURL + 'static/' + trainer.photo"
                :small="true"
            />
        </TableCell>
        <TableCell :asChild="true">
            <div class="flex flex-col justify-start items-start">
                <div class="truncate text-[#FFF]">{{ trainer.surname }} {{ trainer.name[0] + '.' }}</div>
                <div class="truncate text-sm text-gray-400">{{ trainer.phone }}</div>
            </div>
        </TableCell>
        <TableCell :asChild="true">
            <div>
                <span v-if="typeof groups != 'null'">{{ groups ? groups.join(', ').length > 20 ? groups.join(', ').slice(0, 20) + '...' : groups.join(', ') : '—' }}</span>
                <Skeletor v-else width="70" height="15" pill as="div" :shimmer="true"/>
            </div>
        </TableCell>
        <TableCell :asChild="true">
            <div>
                <span v-if="typeof activeStudentsCount == 'number' ">{{ activeStudentsCount }}</span>
                <Skeletor v-else width="40" class="ml-auto" height="15" pill as="div" :shimmer="true"/>
            </div>
        </TableCell>
        <TableCell :asChild="true">
            <div>
                <div class="flex justify-center" v-for="s in ['active',]">
                    <div v-if="s == 'active'" class="bg-[#339989] mx-1 h-[18px] pb-[2px] flex justify-center items-center rounded-full w-[88px] text-[11px] text-center text-[#fff]">
                        <div class="text-[11px] pt-[2px]">
                            aктивний
                        </div>
                    </div>  
                    <div v-if="s == 'archive'" class="bg-[#8FC408] mx-1 h-[18px] pb-[2px] flex justify-center items-center rounded-full w-[88px] text-[11px] text-center text-[#fff]">
                        Архів
                    </div> 
                </div>
            </div>
        </TableCell>
        <TableCell :asChild="true"></TableCell>
        <TableCell :asChild="true" :text-end="true">
            <div class="player-groups__actions-cell">
                <button @click="$emit('openTrainerCard')">
                    <img src="@/assets/icons/pen_icon.svg" class="w-[25px]" alt="edit" @click="$emit('openGroupCard')" />
                </button>
                <button v-if="currentAdminRole != 'supervisor'" @click="$emit('deleteTrainer', trainer)">
                    <img src="@/assets/icons/trash_icon.svg" class="w-[25px]" alt="delete" @click="deleteGroup" />
                </button>
            </div>
        </TableCell>
    </TableRow>
</template>

<script>
    import { ref, onMounted } from 'vue'
    import { getGroupsByTrainerId, getActiveStudentsInGroup } from '@/services/apiRequests'
    import { Skeletor } from 'vue-skeletor'

    export default {
        name: 'trainer-row',

        props: {
            trainer: {
                type: Object,
                required: true
            }
        },

        setup(props, { emit }) {
            const apiURL = ref(process.env.VUE_APP_API_URL)
            const groups = ref(null)
            const activeStudentsCount = ref(null)

            const getActiveStudentByEachGroup = async (groups) => {
                let sum = 0
                for (let i = 0; i < groups.length; i++) {
                    const res = await getActiveStudentsInGroup(groups[i].group_id)
                    sum += res.data
                }
                emit('addCountStudents', sum)
                return sum
            }

            onMounted(async () => {
                const res = await getGroupsByTrainerId(props.trainer.trainer_id)
                groups.value = res.data.map(g => g.name)
                emit('addGroups', {
                    trainer_id: props.trainer.trainer_id,
                    groups: res.data.map(g => g.name)
                })
                activeStudentsCount.value = await getActiveStudentByEachGroup(res.data)
            })

            const currentAdminRole = ref(localStorage.getItem('userType'))

            return {
                apiURL,
                groups,
                activeStudentsCount,
                currentAdminRole
            }
        },

        components: {
            Skeletor
        }
    }
</script>


<style lang="scss" scoped>

    .vue-skeletor {
        background-color: #707070;
        animation: shimmer 1.5s infinite;
        animation-duration: 2s; 
        animation-timing-function: ease-in-out;
        border-radius: 10px;
    }

    /* Default keyframes used in skeletor */
    @keyframes shimmer {
        0% {
            opacity: .5;
            
        }
        50% {
            opacity: 1;
            
        }
        100% {
            opacity: .5;
            
        }
    }

</style>